import MutasiAntarGudang from './MutasiAntarGudang';

export default MutasiAntarGudang;
